

































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'
import Limit from '@/dto/limits/Limit'
import Country from '@/dto/deliveries/Country'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'
import LimitDeleteForm from '@/components/limit/LimitDeleteForm.vue'

@Component({
  components: { LimitDeleteForm },
})
export default class LimitsTableRow extends Vue {
  @Prop(Object)
  public limit: Limit

  @Prop(Object)
  public props: any

  @Prop(Array)
  public countries: Country[]

  isShowConfirmDialog: boolean = false

  get country() {
    return this.countries.find(
      country => country.id === (this.limit.countryId as number)
    )
  }

  get currency(): Currency {
    const currencyCode = this.limit.currency as string
    return DictionariesService.currencies[currencyCode]
  }

  selectLimit() {
    const limitId = this.limit.id as number

    if (this.$route.params.limitId !== limitId.toString())
      this.$router.push({
        name: Routes.limitEdit,
        params: { limitId: limitId.toString() },
      })
  }
}
